module.exports = __webpack_public_path__ + "static/img/应用场景1-位姿测量.e734043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-3/应用场景1-位姿测量.png
// module id = WFJR
// module chunks = 0